import { render, staticRenderFns } from "./VCheckbox.vue?vue&type=template&id=f6a8d37c&"
import script from "./VCheckbox.vue?vue&type=script&lang=ts&"
export * from "./VCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./VCheckbox.vue?vue&type=style&index=0&id=f6a8d37c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports